import axios from '@/libraries/axios/axiosConfig';
import type PostTrailerPhotosResponse from '@/types/PostTrailerPhotosResponse';
import type {
    AssessmentPhotoType,
    AssessmentPhotoSubtype,
} from '@/types/TrailerPhotoAssessmentTypes';
import globalConstants from '@/shared/globalConstants';

export default async function postTrailerPhoto(
    trailerAssessmentId: string | number,
    type: AssessmentPhotoType,
    subtype: AssessmentPhotoSubtype,
    file: File
): Promise<PostTrailerPhotosResponse> {
    const metadata = JSON.stringify({
        photoType:
            globalConstants.trailer.photos.METADATA_PHOTO_TYPE.TRAILER_PHOTO,
        trailerAssessmentId: trailerAssessmentId,
        type: type,
        subType: subtype,
    });

    const formData = new FormData();
    formData.append('metadata', metadata);
    formData.append('file', file);

    try {
        const response = await axios({
            method: 'post',
            url: `${process.env.VUE_APP_EXT_API_URL}api/documents`,
            data: formData,
        });

        return response.data;
    } catch (error) {
        console.error('Failed to upload trailer photo:', error);
        return {
            blobFileName: '',
            contentType: '',
            deleteDate: null,
            documentType: '',
            fileName: '',
            id: '',
            insertDate: null,
            lastAccessedTimestamp: null,
            lastModified: '',
            metadata: { photoType: [] },
            sasUri: null,
            size: 0,
            storageFileName: '',
        };
    }
}
